import { createStyles, makeStyles } from '@material-ui/core'

export default makeStyles((theme) =>
  createStyles({
    postSection: {
      fontFamily: theme.typography.fontFamily,
      '& a': {
        color: theme.palette.primary.main,
        textDecoration: 'none',
        '&:hover': { textDecoration: 'underline' },
      },
      '& h2': theme.typography.h5,
      '& h3': theme.typography.h6,
      '& li': theme.typography.body1,
      '& p': theme.typography.body1,
      '& strong': theme.typography.fontWeightBold,
    },
    featuredImage: { width: '100%' },
  })
)
